"use strict";
// This is a dynamic condition controller.Handlers are regenerated on each call.
// Instead of a static value, we pass the question id to fetch the value from.
// e.g,: rule::UBUBBI_Limit_per_person::lessThanOrEqual::BI_Limit_per_person
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDynamicConditionController = void 0;
const utilsConditions_1 = require("./utilsConditions");
const createDynamicConditionController = (rules) => {
    return (getValue) => {
        const handlers = rules.map(rule => (0, utilsConditions_1.createGenericRule)(rule));
        const isInvalidValue = handlers.some((handler) => !handler.op((0, utilsConditions_1.numberIfNumberlike)(getValue(handler.affectingQuestionId)), (0, utilsConditions_1.numberIfNumberlike)(getValue(handler.comparable))));
        return isInvalidValue;
    };
};
exports.createDynamicConditionController = createDynamicConditionController;
